<div class="error">
    <span class="error__icon glyphicon glyphicon-alert"></span>
    <span class="error__message">{{ message }}</span>
</div>
